// eslint-disable-next-line no-restricted-imports
import { Outlet } from "@tanstack/react-location";

export default Outlet;
